import { Box, Stack, Typography } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { ROUTES } from "helpers/routes";
import QRCode from "qrcode.react";
import { FC } from "react";

const CheckInQrCode: FC<{ value?: string; message?: string }> = ({
  value = undefined,
  message = undefined,
}) => {
  const currentDomain = window.location.origin;
  const theme: Theme = useTheme();

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
      sx={{
        padding: 6,
        width: {
          md: 304,
        },
      }}
    >
      <Box color={theme.palette.common.white} textAlign="center">
        <Typography component="p" color="inherit" variant="caption">
          {message ?? "You can also use your phone to complete check-in"}
        </Typography>
      </Box>
      <Box
        sx={{
          bgcolor: theme.palette.common.white,
          padding: theme.spacing(1),
          paddingBottom: 0,
          borderRadius: theme.spacing(1),
        }}
      >
        <QRCode
          marginSize={0}
          value={`${currentDomain}${value ?? ROUTES.CHECK_IN}`}
          fgColor="#2F6DBF"
        />
      </Box>
    </Stack>
  );
};

export default CheckInQrCode;
